import styled from 'styled-components'

export const StyledAddButton = styled.foreignObject`
    div {
        background: var(--blue-500);
        font-size: 12px;
        border-radius: 100px;
        height: 24px;
        padding: 2px;
        display: flex;
        justify-content: center;
        color: var(--gray-0);

        i {
            padding: 4px;
        }
    }
`

export const PopupSVG = styled.g`
    pointer-events: none;

    rect {
        fill: var(--gray-900);
    }

    text {
        fill: var(--gray-0);
    }

    div {
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: min-content;
        flex-wrap: nowrap;
        white-space: nowrap;
        padding: 8px;
        max-width: 150px;
        height: 30px;
        background: var(--gray-900);
        color: var(--gray-0);

        &.THREAT {
            margin-left: auto;
        }

        &.CONSEQUENCE {
            margin-right: auto;
        }
    }
`

export const AddButtonContainer = styled.g`
    ${PopupSVG} {
        display: none;
    }

    :hover {
        ${PopupSVG} {
            display: unset;
        }
    }
`
